import type { TranslationResources } from '@/i18n/resources/en.ts';
import { adminNb } from '@/i18n/resources/admin-nb.ts';
import { businessNb } from '@/i18n/resources/business-nb.ts';
import { surfacesNb } from '@/i18n/resources/surfaces-nb.ts';

export const nb = {
  ...adminNb,
  ...businessNb,
  ...surfacesNb,
  'language.label': 'Språk',
  'language.english': 'Engelsk',
  'language.norwegian': 'Norsk',
  'language.help': 'Velg språket som brukes i navigasjon, innlogging og vanlige handlinger.',
  'rsvpMoment.confirmedTitle': 'Du skal delta',
  'rsvpMoment.confirmedBody': 'Plassen din på {title} er bekreftet.',
  'rsvpMoment.waitlistedTitle': 'Du står på ventelisten',
  'rsvpMoment.waitlistedBody': 'Du har plass {position}. Vi sier fra hvis en plass blir ledig.',
  'rsvpMoment.requestedTitle': 'Forespørselen er sendt',
  'rsvpMoment.requestedBody': 'Arrangøren vurderer forespørselen før plassen blir bekreftet.',
  'rsvpMoment.pending-paymentTitle': 'Fullfør betalingen',
  'rsvpMoment.pending-paymentBody': 'Plassen er ikke bekreftet før betalingsleverandøren godkjenner betalingen.',
  'rsvpMoment.calendar': 'Legg til i kalender',
  'rsvpMoment.share': 'Inviter eller del',
  'rsvpMoment.ticket': 'Se billettkrav',
  'rsvpMoment.dismiss': 'Lukk bekreftelsen',
  'eventMood.heading': 'Hva har du lyst til?',
  'eventMood.spontaneous': 'Noe spontant',
  'eventMood.meetPeople': 'Møt nye mennesker',
  'eventMood.lowKey': 'Rolig',
  'eventMood.outdoors': 'Utendørs',
  'eventMood.freeTonight': 'Gratis i kveld',
  'eventMood.bringKids': 'Ta med barna',
  'eventMood.counting': 'Sjekker arrangementer i nærheten …',
  'eventMood.results': 'Ingen treff | Ett treff | {count} treff',
  'eventMood.countUnavailable': 'Antallet er utilgjengelig',
  'eventMood.signalUnavailable': 'Dette valget trenger pålitelige arrangementsdata som ikke er tilgjengelige ennå.',
  'eventMood.timezoneUnavailable': 'Velg et sted med tidssonestøtte før du bruker dette valget.',
  'eventMood.availabilityNote': 'Utilgjengelige valg forblir deaktivert til nødvendige arrangementsdata kan gi et ærlig treff.',
  'discoveryFilters.outdoors': 'Utendørs',
  'discoveryFilters.removeOutdoors': 'Fjern utendørsfilter',
  'eventDay.title': 'Dagens arrangementsplan',
  'eventDay.intro': 'De neste nyttige handlingene dine, sortert for dagen.',
  'eventDay.cancelled': 'Avlyst',
  'eventDay.happeningNow': 'Pågår nå',
  'eventDay.nearArrival': 'På tide å gjøre seg klar',
  'eventDay.ended': 'Avsluttet',
  'eventDay.beforeDeparture': 'Senere i dag',
  'eventDay.conflict': 'Tidskonflikt',
  'eventDay.offlineStale': 'Reise og vær kan være bufret',
  'eventDay.accessible': 'Rullestoltilgjengelig',
  'eventDay.routeUnavailable': 'Ingen direkte rute er tilgjengelig. Åpne arrangementet for reisemål og adgangsinformasjon.',
  'eventDay.directions': 'Veibeskrivelse',
  'eventDay.ticket': 'Vis billett',
  'eventDay.chat': 'Åpne chat',
  'eventDay.details': 'Arrangementsdetaljer',
  'eventDay.guestDetails': 'Detaljer for gjestesvar',
  'eventCard.quickActions': 'Private arrangementshandlinger',
  'eventCard.interested': 'Interessert',
  'eventCard.interestedSaved': 'Lagret',
  'eventCard.invite': 'Inviter',
  'eventCard.share': 'Del',
  'eventCard.intentError': 'Den private lagringen kunne ikke oppdateres.',
  'eventCard.socialMutualAttendee': '{name} skal delta',
  'eventCard.socialMutualAttendees': '{name} og {count} du kjenner skal delta',
  'eventCard.socialMutualHost': 'Arrangeres av {name}, som du kjenner',
  'eventCard.socialManyFirstTime': 'Mange deltar for første gang',
  'eventSchedule.eventTime': 'Arrangementstid',
  'eventSchedule.yourTime': 'Din tid',
  'eventSchedule.fallback': 'tidssonen er utilgjengelig; viser UTC',
  'eventSchedule.unavailable': 'Dato og tid er utilgjengelig',
  'eventCard.cancelled': 'Avlyst',
  'eventCard.cancelledLink': '{title}, avlyst',
  'eventCard.showMap': 'Vis kart',
  'eventCard.showPhoto': 'Vis arrangementsbilde',
  'eventCard.mapAlt': 'Kart som viser hvor {title} finner sted',
  'eventCard.mediaUnavailable': 'Arrangementsmediet er utilgjengelig',
  'eventCard.locationUnavailable': 'Sted er ikke oppgitt',
  'eventCard.attendees': 'Ingen deltakere | Én deltaker | {count} deltakere',
  'eventCard.distanceAway': '{distance} unna',
  'eventCard.mutualAttending': 'Ingen gjensidige kontakter deltar | Én gjensidig kontakt deltar | {count} gjensidige kontakter deltar',
  'eventCard.mutualHostedAndAttending':
    'Arrangeres av {name} | Arrangeres av {name} · én gjensidig kontakt deltar | Arrangeres av {name} · {count} gjensidige kontakter deltar',
  'eventCard.environmentIndoor': 'Innendørs',
  'eventCard.environmentOutdoor': 'Utendørs',
  'eventCard.environmentMixed': 'Inne og ute',
  'eventCard.familyFriendly': 'Familievennlig',
  'eventCard.accessible': 'Tilgjengelig med rullestol',
  'groupCard.loading': 'Laster gruppe',
  'groupCard.photoAlt': 'Gruppebilde for {name}',
  'groupCard.mediaUnavailable': 'Gruppebildet er utilgjengelig',
  'groupCard.fallbackDescription': 'Oppdag denne lokale gruppen.',
  'groupCard.members': 'Ingen medlemmer | Ett medlem | {count} medlemmer',
  'groupCard.nextEvent': 'Neste: {title} · {date}',
  'groupCard.nextEventLabel': 'Åpne {title}, gruppens neste arrangement {date}',
  'groupCard.upcomingEvents': 'Ingen kommende arrangementer | Ett kommende arrangement | {count} kommende arrangementer',
  'groupCard.cadenceWeekly': 'Møtes vanligvis hver {weekday}',
  'groupCard.cadenceBiweekly': 'Møtes vanligvis annenhver {weekday}',
  'groupCard.activity.active': 'Aktiv denne måneden',
  'groupCard.activity.steady': 'Møtes og deler denne måneden',
  'groupCard.activity.light': 'Nylig aktiv',
  'groupCard.newCommunity': 'Et nytt fellesskap',
  'groupCard.quietCommunity': 'Ingen offentlig aktivitet ennå',
  'groupActions.signInTitle': 'Bli med i gruppen',
  'groupActions.signInBody': 'Du må logge inn for å bli med i denne gruppen.',
  'groupActions.signIn': 'Logg inn',
  'groupActions.back': 'Tilbake',
  'groupActions.join': 'Bli med i gruppen',
  'groupActions.accept': 'Godta invitasjonen',
  'groupActions.decline': 'Avslå invitasjonen',
  'groupActions.request': 'Be om å bli med',
  'groupActions.invite': 'Inviter personer',
  'groupActions.inviteTooltip': 'Inviter personer til denne gruppen',
  'groupActions.share': 'Del lenke',
  'groupActions.shareTooltip': 'Opprett en delbar gruppeinvitasjonslenke',
  'groupActions.pending': 'Medlemskapet ditt venter på gjennomgang av en administrator.',
  'groupActions.cancelRequest': 'Avbryt forespørselen',
  'groupActions.declinedState': 'Du avslo denne gruppen. Tilbakestill svaret før du kan inviteres igjen.',
  'groupActions.reset': 'Tilbakestill svar',
  'groupActions.invitedBy': '{name} inviterte deg',
  'groupActions.inviterAvatar': 'Profilbilde av {name}',
  'groupActions.cancelTitle': 'Avbryt forespørselen',
  'groupActions.cancelBody': 'Er du sikker på at du vil avbryte forespørselen om å bli med?',
  'groupActions.cancelConfirm': 'Ja, avbryt den',
  'groupActions.cancelDismiss': 'Nei, gå tilbake',
  'groupActions.joinError': 'Kunne ikke bli med i gruppen. Prøv igjen.',
  'groupActions.acceptError': 'Kunne ikke godta invitasjonen. Prøv igjen.',
  'groupActions.declineError': 'Kunne ikke avslå invitasjonen. Prøv igjen.',
  'groupActions.requestError': 'Kunne ikke sende forespørselen. Prøv igjen.',
  'groupActions.cancelError': 'Kunne ikke avbryte forespørselen. Prøv igjen.',
  'groupActions.resetError': 'Kunne ikke tilbakestille svaret. Prøv igjen.',
  'groupActions.editGroup': 'Rediger gruppen',
  'groupActions.leaveGroup': 'Forlat gruppen',
  'groupActions.leaveGroupTitle': 'Forlat gruppen',
  'groupActions.leaveGroupBody': 'Er du sikker på at du vil forlate gruppen? Handlingen kan ikke angres.',
  'groupActions.leaveGroupConfirm': 'Ja, forlat den',
  'groupActions.leaveGroupSuccess': 'Du har forlatt gruppen.',
  'groupActions.leaveGroupError': 'Kunne ikke forlate gruppen. Prøv igjen.',
  'groupActions.deleteGroup': 'Slett gruppen',
  'groupActions.deleteGroupTitle': 'Slett gruppen',
  'groupActions.deleteGroupBody': 'Er du sikker på at du vil slette gruppen? Handlingen kan ikke angres.',
  'groupActions.deleteGroupConfirm': 'Ja, slett den',
  'groupActions.deleteGroupSuccess': 'Gruppen ble slettet.',
  'groupActions.deleteGroupError': 'Kunne ikke slette gruppen. Prøv igjen.',
  'groupForm.createTitle': 'Opprett gruppe',
  'groupForm.editTitle': 'Rediger gruppe',
  'groupForm.settings': 'Innstillinger',
  'groupForm.permissions': 'Medlemstillatelser',
  'groupForm.create': 'Opprett gruppe',
  'groupForm.save': 'Lagre endringer',
  'groupForm.cancel': 'Avbryt',
  'groupForm.signInRequired': 'Du må være logget inn for å opprette en gruppe.',
  'groupForm.field.image': 'bilde',
  'groupForm.field.name': 'navn',
  'groupForm.field.description': 'beskrivelse',
  'groupForm.field.category': 'kategori',
  'groupForm.requiredError': 'Kontroller disse obligatoriske feltene: {fields}',
  'groupForm.created': 'Gruppen ble opprettet.',
  'groupForm.updated': 'Gruppen ble oppdatert.',
  'groupForm.createError': 'Gruppen kunne ikke opprettes: {message}',
  'groupForm.updateError': 'Gruppen kunne ikke oppdateres: {message}',
  'groupForm.name': 'Gruppenavn',
  'groupForm.namePlaceholder': 'For eksempel fotballklubb eller musikklubb',
  'groupForm.nameMissing': 'Skriv inn et gruppenavn på minst 5 tegn.',
  'groupForm.description': 'Beskrivelse',
  'groupForm.descriptionPlaceholder': 'Fortell folk om gruppen',
  'groupForm.descriptionMissing': 'Skriv inn en beskrivelse på minst 5 tegn.',
  'groupForm.imageMissing': 'Legg til et gruppebilde.',
  'groupForm.category': 'Kategori',
  'groupForm.categoryHelp': 'Velg kategorien som beskriver gruppen best, slik at folk kan finne den.',
  'groupForm.categoryMissing': 'Velg en gruppekategori.',
  'groupForm.public': 'Offentlig gruppe',
  'groupForm.publicEnabled': 'Aktivert — folk kan finne gruppen gjennom Utforsk grupper.',
  'groupForm.publicDisabled': 'Deaktivert — bare inviterte personer kan se gruppen.',
  'groupForm.location': 'Gruppested',
  'groupForm.locationHelp': 'Velg et sted for å hjelpe folk med å finne gruppen.',
  'groupForm.joinRestrictions': 'Begrensninger for medlemskap',
  'groupForm.joinApprovalEnabled': 'Aktivert — administratorer må godkjenne nye medlemmer.',
  'groupForm.joinApprovalPublic': 'Deaktivert — alle kan bli med i gruppen.',
  'groupForm.joinApprovalPrivate': 'Deaktivert — inviterte personer kan bli med i gruppen.',
  'groupForm.permission.invite': 'Inviter andre',
  'groupForm.permission.inviteEnabled': 'Aktivert — medlemmer kan invitere nye personer.',
  'groupForm.permission.inviteDisabled': 'Deaktivert — bare administratorer kan invitere nye personer.',
  'groupForm.permission.posts': 'Opprett innlegg',
  'groupForm.permission.postsEnabled': 'Aktivert — medlemmer kan opprette innlegg.',
  'groupForm.permission.postsDisabled': 'Deaktivert — bare administratorer kan opprette innlegg.',
  'groupForm.permission.events': 'Opprett arrangementer',
  'groupForm.permission.eventsEnabled': 'Aktivert — medlemmer kan opprette gruppearrangementer.',
  'groupForm.permission.eventsDisabled': 'Deaktivert — bare administratorer kan opprette gruppearrangementer.',
  'groupForm.permission.inviteSummary': 'Inviter andre til gruppen',
  'groupForm.permission.postsSummary': 'Opprett innlegg',
  'groupForm.permission.eventsSummary': 'Opprett arrangementer',
  'eventDetail.mediaUnavailable': 'Arrangementsmediet er utilgjengelig',
  'eventDetail.photoAlt': '{title}, bilde {number}',
  'eventDetail.morePhotos': '+{count} bilder',
  'eventDetail.viewGallery': 'Vis alle {count} bilder',
  'eventDetail.gallery': 'Bilder fra arrangementet',
  'eventDetail.tab.about': 'Om',
  'eventDetail.tab.updates': 'Oppdateringer',
  'eventDetail.tab.chat': 'Samtale',
  'eventDetail.tab.manage': 'Administrer',
  'eventDetail.status.recurring': 'Gjentakende',
  'eventDetail.status.cancelled': 'Avlyst',
  'eventDetail.status.public': 'Offentlig',
  'eventDetail.status.private': 'Privat',
  'eventDetail.partOf': 'Del av {title}',
  'eventDetail.parentEvent': 'hovedarrangementet',
  'eventDetail.location': 'Sted',
  'eventDetail.locationUnavailable': 'Sted er ikke oppgitt',
  'eventDetail.hostedBy': 'Arrangeres av',
  'eventDetail.verifiedVenue': 'Verifisert sted',
  'eventDetail.capacity': 'Tilgjengelighet',
  'eventDetail.capacityUnlimited': 'Ledige plasser',
  'eventDetail.capacityRemaining': '{remaining} av {maximum} plasser ledige',
  'eventDetail.capacityFull': 'Arrangementet er fullt',
  'eventDetail.capacityWaitlist': 'Arrangementet er fullt · venteliste tilgjengelig',
  'eventDetail.secondaryActions': 'Arrangementshandlinger',
  'eventDetail.save': 'Lagre',
  'eventDetail.saved': 'Lagret',
  'eventDetail.saving': 'Lagrer…',
  'eventDetail.share': 'Del',
  'eventDetail.sharing': 'Deler…',
  'eventDetail.action.join': 'Bli med',
  'eventDetail.action.join_waitlist': 'Bli med på ventelisten',
  'eventDetail.action.guest_rsvp': 'Svar uten konto',
  'eventDetail.action.pay': 'Betal {price} med Vipps',
  'eventDetail.action.view_ticket': 'Vis billett',
  'eventDetail.action.confirm_offer': 'Bekreft plassen',
  'eventDetail.action.attending': 'Du deltar',
  'eventDetail.action.guest_attending': 'Du deltar som {name}',
  'eventDetail.action.waitlisted': 'Du står på ventelisten',
  'eventDetail.action.guest_waitlisted': 'Gjesteplass {position} på ventelisten',
  'eventDetail.action.pending': 'Venter på godkjenning fra arrangøren',
  'eventDetail.action.hosting': 'Du er arrangør',
  'eventDetail.action.co_hosting': 'Du er medarrangør',
  'eventDetail.action.cancelled': 'Arrangementet er avlyst',
  'eventDetail.action.closed': 'Påmeldingen er stengt',
  'eventDetail.action.full': 'Arrangementet er fullt',
  'eventDetail.action.unavailable': 'Arrangementet er utilgjengelig',
  'eventDetail.action.updating': 'Oppdaterer…',
  'eventDetail.loading': 'Laster arrangementsdetaljer …',
  'eventDetail.unavailableTitle': 'Arrangementet er utilgjengelig',
  'eventDetail.unavailableBody': 'Arrangementet kan være privat, fjernet eller midlertidig utilgjengelig.',
  'eventDetail.retry': 'Prøv igjen',
  'eventDetail.close': 'Lukk',
  'eventDetail.paymentRedirectError': 'Den sikre betalingssiden hos Vipps kunne ikke åpnes. Påmeldingen er ikke bekreftet.',
  'language.saved': 'Språkvalget er lagret.',
  'brand.homeLink': 'Vennevent-forsiden',
  'accessibility.pageLoaded': 'Siden {name} er lastet',
  'pageTitle.search': 'Søk',
  'pageTitle.myFeed': 'Min strøm',
  'pageTitle.myEvents': 'Mine arrangementer',
  'pageTitle.eventUpdates': 'Arrangementsoppdateringer',
  'pageTitle.myGroups': 'Mine grupper',
  'pageTitle.groupUpdates': 'Gruppeoppdateringer',
  'pageTitle.createGroup': 'Opprett gruppe',
  'pageTitle.editGroup': 'Rediger gruppe',
  'pageTitle.exploreGroups': 'Utforsk grupper og virksomheter',
  'search.title': 'Søk i Vennevent',
  'search.label': 'Søk i Vennevent',
  'search.placeholder': 'Arrangementer, grupper, bedrifter eller personer',
  'search.searching': 'Søker',
  'search.filters': 'Filtre for søkeresultater',
  'search.type.events': 'Arrangementer',
  'search.type.groups': 'Grupper',
  'search.type.businesses': 'Bedrifter',
  'search.type.people': 'Personer',
  'search.upcomingEvents': 'Kommende arrangementer',
  'search.radius': 'Innenfor',
  'search.radiusOption': '{distance} km',
  'search.recent': 'Nylige søk',
  'search.clear': 'Tøm',
  'search.recentPrivacy': 'Søk lagres bare i denne nettleseren.',
  'search.minimumLength': 'Skriv inn minst to tegn.',
  'search.unavailable': 'Søket er midlertidig utilgjengelig.',
  'search.retry': 'Prøv igjen',
  'search.noResults': 'Ingen resultater for «{query}»',
  'search.noResultsHelp': 'Prøv et kortere søk, en annen stavemåte eller flere resultattyper.',
  'search.showMore': 'Vis flere resultater',
  'search.memberFallback': 'Vennevent-medlem',
  'search.distanceAway': '{distance} unna',
  'nav.primary': 'Hovednavigasjon',
  'nav.search': 'Søk',
  'nav.feed': 'Min strøm',
  'nav.feedShort': 'Strøm',
  'nav.events': 'Arrangementer',
  'nav.eventsShort': 'Eventer',
  'nav.groups': 'Grupper',
  'nav.account': 'Konto',
  'nav.settings': 'Innstillinger',
  'nav.login': 'Logg inn',
  'nav.signIn': 'Logg inn',
  'nav.accountSettings': 'Kontoinnstillinger',
  'nav.admin': 'Plattformadministrasjon',
  'nav.moderation': 'Modereringsoversikt',
  'events.navigation.label': 'Arrangementsseksjoner',
  'events.navigation.explore': 'Utforsk',
  'events.navigation.updates': 'Oppdateringer',
  'events.navigation.myEvents': 'Mine arrangementer',
  'events.exploreMode.label': 'Utforsk arrangementer',
  'events.exploreMode.all': 'Alle',
  'events.exploreMode.nearbyNow': 'I nærheten nå',
  'events.exploreMode.pulse': 'Puls',
  'pulse.nextSevenDays': 'Neste sju dager',
  'pulse.thisWeekend': 'Denne helgen',
  'pulse.title': 'Det skjer ting i {location}',
  'pulse.benefit': 'Se hvor offentlige arrangementer får fart, uten sporing av personer.',
  'pulse.summary.low': 'Noe er på gang i {location}: {count} offentlige arrangementer.',
  'pulse.summary.medium': 'Det er livlig i {location}, med {count} offentlige arrangementer i nærheten.',
  'pulse.summary.high': 'Det yrer i {location}, med {count} offentlige arrangementer i nærheten.',
  'pulse.about': 'Slik fungerer pulsen',
  'pulse.privacy':
    'Dette serverberegnede sammendraget bruker bare tilbudet av offentlige arrangementer. Det bruker aldri deltakelse, søk, lagringer, følgere, tilgjengelighet, nettleseraktivitet eller nøyaktig personlig posisjon.',
  'pulse.attribution': 'Tallene dekker det valgte området og skjules når en personverntrygg minstegrense ikke er nådd.',
  'pulse.selectedArea': 'Det valgte området',
  'pulse.otherCategory': 'Annet',
  'pulse.dateRangeLabel': 'Tidsrom for puls',
  'pulse.signInTitle': 'Se hva som tar form i nærheten',
  'pulse.signInBody': 'Logg inn for å bruke det valgte området og utforske den personverntrygge ukepulsen.',
  'pulse.signInAction': 'Logg inn for å se pulsen',
  'pulse.locationTitle': 'Velg et område å utforske',
  'pulse.locationBody': 'Velg et sted i arrangementsutforskingen, så oppsummerer vi tilbudet av offentlige arrangementer.',
  'pulse.chooseLocation': 'Velg sted',
  'pulse.loading': 'Laster nabolagspuls',
  'pulse.errorTitle': 'Pulsen er utilgjengelig',
  'pulse.errorBody': 'Vi klarte ikke å oppdatere dette sammendraget av offentlige arrangementer.',
  'pulse.retry': 'Prøv igjen',
  'pulse.insufficientTitle': 'Det finnes ikke nok offentlige data for et trygt sammendrag',
  'pulse.insufficientBody': 'Vi kan ikke beskrive {location} ennå. Det betyr ikke at området er stille; små resultatmengder holdes skjult.',
  'pulse.stale': 'Viser et mellomlagret sammendrag fra {date}.',
  'pulse.refresh': 'Oppdater',
  'pulse.publicEvents': 'Offentlige arrangementer',
  'pulse.weekendEvents': 'Helgearrangementer',
  'pulse.activeVenues': 'Aktive verifiserte steder',
  'pulse.categoryTitle': 'Dette er aktivt',
  'pulse.categoryHelp': 'Båndene viser et grovt tilbud av offentlige arrangementer. Etikettene gir samme konklusjon uten farge.',
  'pulse.categoryFilterLabel': 'Utforsk en kategori',
  'pulse.allCategories': 'Alle kategorier',
  'pulse.level.low': 'Noe aktivitet',
  'pulse.level.medium': 'Livlig',
  'pulse.level.high': 'Svært aktivt',
  'pulse.eventCount': 'Ingen arrangementer | Ett arrangement | {count} arrangementer',
  'pulse.trendUnavailable': 'Sammenligningen er skjult fordi én uke er under personverngrensen',
  'pulse.trend': '{count} sammenlignet med forrige uke',
  'beforeYouGo.eyebrow': 'Før du drar',
  'beforeYouGo.title': 'Oppløpet til arrangementet',
  'beforeYouGo.starts': 'Starter {date}',
  'beforeYouGo.hostPrompt': 'Legg til spørsmål',
  'beforeYouGo.updates': 'Ingen oppdateringer | Én oppdatering | {count} oppdateringer',
  'beforeYouGo.chat': 'Åpne chat | Én chatmelding | {count} chatmeldinger',
  'beforeYouGo.ticketReady': 'Billett og inngang',
  'beforeYouGo.weatherHint': 'Sjekk værmeldingen før du drar',
  'beforeYouGo.bringHint': 'Se oppdateringene for hva du bør ta med',
  'beforeYouGo.promptType': 'Type spørsmål',
  'beforeYouGo.icebreaker': 'Isbryter',
  'beforeYouGo.poll': 'Avstemning',
  'beforeYouGo.promptEnglish': 'Spørsmål på engelsk',
  'beforeYouGo.promptNorwegian': 'Spørsmål på norsk (valgfritt)',
  'beforeYouGo.pollOptions': 'Svaralternativer',
  'beforeYouGo.pollOptionsHint': 'Ett alternativ per linje, to til seks alternativer',
  'beforeYouGo.wholeSeries': 'Bruk for hele den gjentakende serien',
  'beforeYouGo.publish': 'Publiser spørsmål',
  'beforeYouGo.closePrompt': 'Lukk spørsmål',
  'beforeYouGo.audience': 'Synlig for bekreftede deltakere',
  'beforeYouGo.responses': 'Ingen svar | Ett svar | {count} svar',
  'beforeYouGo.responded': 'Svaret ditt er lagret.',
  'beforeYouGo.sharedResponses': 'Svar fra deltakere',
  'beforeYouGo.responseHint': 'Del et kort svar med bekreftede deltakere',
  'beforeYouGo.respond': 'Svar',
  'beforeYouGo.skip': 'Hopp over spørsmålet',
  'beforeYouGo.error': 'Oppløpet til arrangementet kunne ikke oppdateres.',
  'reflection.title': 'Vil du huske dette?',
  'reflection.body': 'Legg til én privat detalj fra {title} mens den fortsatt er fersk.',
  'reflection.dismiss': 'Avslå denne refleksjonen permanent',
  'reflection.addNote': 'Legg til notat',
  'reflection.addPhoto': 'Legg til bilde',
  'reflection.favoriteHost': 'Favorittvert',
  'reflection.private': 'Privat for deg. Avslag stopper spørsmålet med mindre du åpner det igjen fra Minner.',
  'reflection.saved': 'Lagret i ditt private minne.',
  'reflection.error': 'Refleksjonen kunne ikke oppdateres.',
  'memoryRecap.eyebrow': 'Måneden din i minner',
  'memoryRecap.title': 'Din {month}',
  'memoryRecap.events': 'Ingen huskede arrangementer | Ett husket arrangement | {count} huskede arrangementer',
  'memoryRecap.photoAlt': 'Privat minnebilde {index}',
  'memoryRecap.private': 'Bygges bare fra dine bevarte private minner. Når et minne fjernes, oppdateres oppsummeringen.',
  'memoryCard.saved': 'Minnet er lagret.',
  'memoryCard.saveError': 'Kunne ikke lagre dette minnet.',
  'memoryCard.deleteTitle': 'Slette dette minnet?',
  'memoryCard.deleteBody': 'Det private notatet og opplastede bilder slettes permanent.',
  'memoryCard.deleteAction': 'Slett minne',
  'memoryCard.keepAction': 'Behold minnet',
  'memoryCard.deleted': 'Minnet er slettet.',
  'memoryCard.deleteError': 'Kunne ikke slette dette minnet.',
  'memoryCard.photoAlt': 'Minnebilde {index} fra {title}',
  'memoryCard.hostedBy': 'Arrangert av {name}',
  'memoryCard.favoriteHost': 'Favorittvert',
  'memoryCard.edit': 'Rediger minne',
  'memoryCard.privateNote': 'Privat notat',
  'memoryCard.notePlaceholder': 'Hva vil du gjerne huske?',
  'memoryCard.favoriteThisHost': 'Gjør denne verten til favoritt',
  'memoryCard.privateArchive': 'Bare synlig i ditt private arkiv.',
  'memoryCard.privatePhotos': 'Private bilder',
  'memoryCard.removeSavedPhoto': 'Fjern lagret bilde',
  'memoryCard.removeSelectedPhoto': 'Fjern valgt bilde',
  'memoryCard.addPhotos': 'Legg til bilder',
  'memoryCard.saveAction': 'Lagre minne',
  'memoryCard.reflectAgain': 'Reflekter igjen',
  'participationHistory.added': 'Lagt til i minnene dine.',
  'participationHistory.createError': 'Kunne ikke opprette dette minnet.',
  'participationHistory.reopenError': 'Kunne ikke åpne refleksjonen igjen.',
  'participationHistory.private': 'Privat for deg',
  'participationHistory.title': 'Minner',
  'participationHistory.body': 'Ta vare på private notater og bilder fra arrangementer du deltok på.',
  'participationHistory.export': 'Eksporter',
  'participationHistory.recent': 'Nylige arrangementer',
  'participationHistory.recentBody': 'Legg til et arrangement for å bevare det etter at selve arrangementet utløper.',
  'continuity.memoryAdded': 'Lagt til i dine private minner.',
  'continuity.memoryError': 'Kunne ikke legge til dette minnet.',
  'continuity.hostRemoved': 'Verten er fjernet fra Lagrede personer.',
  'continuity.hostSaved': 'Verten er lagret privat.',
  'continuity.hostError': 'Kunne ikke oppdatere Lagrede personer.',
  'continuity.personSaved': '{name} er lagret privat.',
  'continuity.personError': 'Kunne ikke lagre deltakeren, eller personen er allerede lagret.',
  'continuity.title': 'Ta med deg det fine videre',
  'continuity.body': 'Velg hva du vil ta vare på eller gjøre videre. Deltakelse oppretter aldri en sosial forbindelse automatisk.',
  'continuity.dismissLabel': 'Avslå forslag etter arrangementet',
  'continuity.dismiss': 'Avslå',
  'continuity.inMemories': 'I minnene dine',
  'continuity.addMemory': 'Legg til privat minne',
  'continuity.hostSavedAction': 'Verten er lagret',
  'continuity.saveHost': 'Lagre verten privat',
  'continuity.peopleTitle': 'Personer du sjekket inn sammen med',
  'continuity.peopleBody': 'Bare verifiserte deltakere vises. Lagring er privat og sender aldri en kontaktforespørsel.',
  'continuity.nextAndSimilar': 'Neste forekomster og lignende arrangementer',
  'continuity.similar': 'Lignende arrangementer',
  'events.action.makePlans': 'Lag planer',
  'events.action.createEvent': 'Opprett arrangement',
  'admin.impersonation.action': 'Opptre som bruker',
  'admin.impersonation.confirm':
    'Vil du opptre som {name} i opptil 15 minutter? Du får alle kontotillatelsene deres, og alle åpne Vennevent-faner bytter identitet.',
  'admin.impersonation.reason': 'Begrunnelse for å opptre som denne brukeren',
  'admin.impersonation.reasonRequired': 'Begrunnelsen må inneholde minst tre tegn.',
  'admin.impersonation.startFailed': 'Kunne ikke starte brukeretterligning.',
  'admin.impersonation.bannerTitle': 'Du opptrer som {name}',
  'admin.impersonation.bannerBody': 'Du har alle tillatelsene til brukeren. Økten utløper om omtrent {minutes} minutter.',
  'admin.impersonation.exit': 'Avslutt brukeretterligning',
  'auth.entryHeading': 'Opprett en konto eller logg inn',
  'auth.entryIntro': 'Ny på Vennevent? Opprett en konto. Har du allerede en? Logg inn for å fortsette.',
  'auth.googleContinue': 'Fortsett med Google',
  'auth.googlePending': 'Fortsetter med Google…',
  'auth.googleError': 'Kunne ikke fortsette med Google. Prøv igjen eller bruk e-post.',
  'auth.emailContinue': 'Fortsett med e-post',
  'auth.back': 'Nei takk. Ta meg tilbake!',
  'auth.consent': 'Ved å fortsette bekrefter du at du har lest',
  'auth.privacy': 'personvernerklæringen',
  'auth.cropPhoto': 'Beskjær profilbildet',
  'auth.cancel': 'Avbryt',
  'auth.createAccount': 'Opprett konto',
  'auth.signIn': 'Logg inn',
  'auth.modeSelector': 'Valg for e-postautentisering',
  'auth.createAccountHeading': 'Opprett kontoen din',
  'auth.signInHeading': 'Logg inn på kontoen din',
  'auth.yourName': 'Navnet ditt',
  'auth.nameInvalid': 'Skriv inn et navn',
  'auth.emailAddress': 'E-postadresse',
  'auth.emailInvalid': 'Skriv inn en gyldig e-postadresse',
  'auth.addProfilePhoto': 'Legg til et profilbilde',
  'auth.profilePhotoHelp': 'Valgfritt. Du kan legge til eller endre dette senere i Innstillinger.',
  'auth.selectProfilePhoto': 'Velg profilbilde',
  'auth.createAccountSubmit': 'Opprett konto med e-post',
  'auth.signInSubmit': 'Logg inn med e-post',
  'auth.sendingCode': 'Sender kode…',
  'auth.codeHelp': 'Vi sender deg en engangskode på e-post. Skriv den inn på neste skjerm for å fortsette.',
  'auth.confirmHeading': 'Skriv inn koden',
  'auth.confirmHelp': 'Skriv inn engangskoden vi sendte til e-postadressen din.',
  'auth.confirmCode': 'Bekreft kode',
  'auth.confirmingCode': 'Bekrefter kode…',
  'auth.genericError': 'Noe gikk galt. Prøv igjen senere.',
  'onboarding.saveError': 'Kunne ikke lagre fremdriften. Prøv igjen.',
  'onboarding.locationUnavailable': 'Posisjon er ikke tilgjengelig i denne nettleseren. Du kan fortsette uten den.',
  'onboarding.nearCurrentLocation': 'Nær min nåværende posisjon',
  'onboarding.locationNotShared': 'Posisjonen ble ikke delt. Du kan fortsette og velge et sted i Utforsk.',
  'onboarding.finishError': 'Kunne ikke fullføre introduksjonen. Valgene dine er fortsatt på denne skjermen.',
  'onboarding.welcome': 'Velkommen til Vennevent',
  'onboarding.step': 'Trinn {current} av {total}',
  'onboarding.progress': 'Fremdrift i introduksjonen',
  'onboarding.introTitle': 'Finn fine ting som skjer i nærheten',
  'onboarding.introBody': 'Vennevent hjelper deg med å oppdage arrangementer og grupper uten å bygge en skjult annonseprofil.',
  'onboarding.privacyBody': 'Arrangementer, samtaler og medier utløper i henhold til lagringsperiodene. Valgene her tilpasser bare utforskningsfiltrene dine.',
  'onboarding.privacyLink': 'Les personvernerklæringen.',
  'onboarding.interestsTitle': 'Hva høres interessant ut?',
  'onboarding.interestsBody': 'Velg så mange du vil, eller hopp over trinnet. Du kan endre filtrene når du utforsker.',
  'onboarding.locationTitle': 'Begynn et sted i nærheten',
  'onboarding.locationBody':
    'Posisjon er valgfritt. Hvis du velger det, lagres bare avrundede koordinater som introduksjonsvalg. Nettleserposisjonen din forespørres først når du trykker på knappen.',
  'onboarding.useLocation': 'Bruk omtrentlig posisjon',
  'onboarding.radius': 'Utforskningsradius: {radius} km',
  'onboarding.preferencesTitle': 'Dine valg',
  'onboarding.preferencesBody': 'Velg hvordan Vennevent starter. Tillatelse til nettleservarsler forespørres senere når du slår det på i Innstillinger.',
  'onboarding.emailNotifications': 'Send meg e-post om relevant aktivitet',
  'onboarding.pushNotifications': 'Husk at jeg ønsker pushvarsler',
  'onboarding.skip': 'Hopp over introduksjonen',
  'onboarding.organizer': 'Jeg arrangerer aktiviteter',
  'onboarding.back': 'Tilbake',
  'onboarding.explore': 'Begynn å utforske',
  'onboarding.continue': 'Fortsett',
  'settings.title': 'Innstillinger',
  'settings.business': 'Virksomhet',
  'settings.profile': 'Profil',
  'settings.availability': 'Tilgjengelighet',
  'settings.people': 'Personer',
  'settings.notifications': 'Varsler',
  'settings.language': 'Språk',
  'settings.account': 'Konto',
  'settings.privacy': 'Personvern og data',
  'settings.moderation': 'Moderering',
  'settings.admin': 'Administrasjon',
  'settings.intro': 'Administrer profil, preferanser og konto.',
  'settings.overviewTitle': 'Velg en innstilling',
  'settings.overviewDescription': 'Innstillingene er gruppert etter hva de påvirker, slik at du enkelt finner riktig kontroll.',
  'settings.sectionsAria': 'Innstillingsseksjoner',
  'settings.back': 'Tilbake til innstillinger',
  'settings.backToContext': 'Tilbake til {destination}',
  'settings.context.groupUpdates': 'gruppeoppdateringer',
  'settings.group.workspace': 'Arbeidsområde',
  'settings.group.personal': 'Personlig',
  'settings.group.preferences': 'Preferanser',
  'settings.group.account': 'Konto',
  'settings.group.management': 'Administrasjon',
  'settings.description.business': 'Administrer arrangementssted og virksomhetsverktøy',
  'settings.description.profile': 'Din offentlige identitet og synlighet',
  'settings.description.availability': 'Når du er ledig til å møtes',
  'settings.description.people': 'Lagrede personer, kretser og kontakter',
  'settings.description.notifications': 'Levering, påminnelser og aktivitetsstrøm',
  'settings.description.language': 'Språk, aktivitetsstrøm og arrangementer',
  'settings.description.account': 'Innlogging, kjøp og sikkerhet',
  'settings.description.privacy': 'Synlighet, tilgang, eksport og sletting',
  'settings.description.moderation': 'Gå gjennom rapporter og hold fellesskapet trygt',
  'settings.description.admin': 'Administrer plattformdrift og utgivelser',
  'settings.save': 'Lagre språk',
  'settings.saving': 'Lagrer…',
  'settings.saveChanges': 'Lagre endringer',
  'settings.discard': 'Forkast',
  'settings.keepEditing': 'Fortsett å redigere',
  'settings.unsavedTitle': 'Forkaste ulagrede endringer?',
  'settings.unsavedBody': 'Endringene dine er ikke lagret. Vil du forkaste dem og forlate denne delen?',
  'settings.profileSaved': 'Profilen er lagret.',
  'settings.notificationsSaved': 'Varslingsinnstillingene er lagret.',
  'settings.preferencesSaved': 'Appinnstillingene er lagret.',
  'charts.platformTrend.title': 'Daglig plattformvekst',
  'charts.platformTrend.aria': 'Linjediagram over daglige nye brukere, arrangementer og grupper de siste 30 dagene.',
  'charts.launchFunnel.title': 'Arrangørtrakt',
  'charts.launchFunnel.aria': 'Liggende stolpediagram over antall arrangører på hvert aktiveringstrinn.',
  'charts.cohorts.title': 'Største anskaffelseskohorter',
  'charts.cohorts.aria': 'Gruppert stolpediagram som sammenligner arrangører, aktiverte arrangører og beholdte grupper i de ti største anskaffelseskohortene.',
  'charts.business.title': 'Nylige arrangementsresultater',
  'charts.business.aria': 'Kombinasjonsdiagram som sammenligner visninger, registreringer og oppmøte for de tolv nyeste målte arrangementene.',
  'charts.series.users': 'Brukere',
  'charts.series.events': 'Arrangementer',
  'charts.series.groups': 'Grupper',
  'charts.series.organizers': 'Arrangører',
  'charts.series.activated': 'Aktiverte arrangører',
  'charts.series.retainedGroups': 'Beholdte grupper',
  'charts.series.impressions': 'Visninger i utforskning',
  'charts.series.registrations': 'Registreringer',
  'charts.series.attendance': 'Oppmøte',
  'charts.axis.participation': 'Registreringer og oppmøte',
  'charts.axis.discovery': 'Visninger i utforskning',
  'home.hello': 'Hei {name}',
  'home.logout': 'Logg ut',
  'common.loading': 'Laster…',
  'common.retry': 'Prøv igjen',
  'common.save': 'Lagre',
  'common.cancel': 'Avbryt',
  'common.error': 'Noe gikk galt. Prøv igjen.',
  'modal.close': 'Lukk dialogvindu',
  'modal.eventDetails': 'Arrangementsdetaljer',
  'modal.groupDetails': 'Gruppedetaljer',
  'modal.subEventDetails': 'Øktdetaljer',
  'modal.businessDetails': 'Bedriftsdetaljer',
  'modal.comments': 'Kommentarer',
  'modal.members': 'Gruppemedlemmer',
  'modal.attendees': 'Arrangementsdeltakere',
  'modal.companyChat': 'Bedriftssamtale',
  'modal.planDetails': 'Plandetaljer',
  'modal.orders': 'Bestillinger',
  'modal.tickets': 'Billetter',
  'modal.privacy': 'Personvernerklæring',
  'modal.releaseNotes': 'Versjonsmerknader',
  'modal.profile': 'Profil',
  'modal.groupInvitation': 'Gruppeinvitasjon',
  'modal.createEvent': 'Opprett arrangement',
  'modal.editEvent': 'Rediger arrangement',
  'modal.createGroup': 'Opprett gruppe',
  'modal.editGroup': 'Rediger gruppe',
  'modal.createPlan': 'Opprett plan',
  'modal.onboarding': 'Kom i gang',
  'modal.organizerSetup': 'Arrangøroppsett',
  'modal.resourceBooking': 'Bestill en ressurs',
  'modal.businessApplication': 'Bedriftssøknad',
  'modal.contact': 'Kontaktopplysninger',
  'modal.contactImport': 'Importer kontakter',
  'modal.people': 'Administrer personer',
  'modal.peopleInvitation': 'Inviter personer',
  'modal.avatar': 'Rediger profilbilde',
  'modal.avatarCropping': 'Beskjær profilbilde',
  'modal.userProfile': 'Brukerprofil',
  'modal.admin': 'Plattformadministrasjon',
  'modal.moderation': 'Innholdsmoderering',
  'modal.eventFilters': 'Filtrer arrangementer',
  'modal.groupInviteLinks': 'Del invitasjonslenke',
  'eventDiscovery.locationLoading': 'Finner et område for arrangementsutforsking …',
  'eventDiscovery.locationUnavailableTitle': 'Velg hvor du vil utforske',
  'eventDiscovery.locationBenefitTitle': 'Finn noe som skjer i nærheten',
  'eventDiscovery.locationUnavailableBody':
    'Vi kunne ikke finne et omtrentlig område. Velg en by, bruk nåværende posisjon eller prøv det private omtrentlige oppslaget på nytt.',
  'eventDiscovery.locationDeniedTitle': 'Posisjonstilgang ble ikke tillatt',
  'eventDiscovery.locationDeniedBody': 'Nettleseren delte ikke posisjonen. Du kan fortsatt velge en by eller prøve omtrentlig posisjon på nytt.',
  'eventDiscovery.locationErrorBody': 'Posisjonen kunne ikke lastes. Kontroller tilkoblingen, prøv igjen eller velg en by i stedet.',
  'eventDiscovery.chooseLocation': 'Velg et sted',
  'eventDiscovery.useCurrentLocation': 'Bruk nåværende posisjon',
  'eventDiscovery.retryApproximate': 'Prøv omtrentlig posisjon på nytt',
  'eventDiscovery.locationPrivacy': 'Du kan alltid velge et sted manuelt. Omtrentlig oppslag bruker ikke den nøyaktige GPS-posisjonen din.',
  'eventDiscovery.locationSearchPlaceholder': 'Velg en by eller et sted',
  'eventDiscovery.chooseLocationBeforeMap': 'Velg et sted for å forhåndsvise utforskingsområdet og avstanden.',
  'eventDiscovery.eventsLoading': 'Laster arrangementer',
  'eventDiscovery.resetFilters': 'Nullstill filtre',
  'discoveryState.retry': 'Prøv igjen',
  'discoveryState.reset': 'Nullstill',
  'discoveryState.viewMap': 'Vis kart',
  'discoveryState.exploreEvents': 'Utforsk arrangementer',
  'discoveryState.selectedArea': 'valgt område',
  'discoveryState.anyLocation': 'alle steder',
  'discoveryState.context': '{location} · {constraints}',
  'discoveryState.event.errorTitle': 'Arrangementene kunne ikke lastes',
  'discoveryState.event.errorBody': 'Kontroller tilkoblingen og prøv å laste arrangementene på nytt.',
  'discoveryState.event.emptyTitle': 'Ingen arrangementer funnet nær {location}',
  'discoveryState.event.emptyBody': 'Kartet kan vise aktivitet like utenfor dette listeområdet.',
  'discoveryState.event.emptyBroaden': 'Du kan også prøve {suggestions}.',
  'discoveryState.event.suggestion.radius': 'en større avstand',
  'discoveryState.event.suggestion.date': 'et større datointervall',
  'discoveryState.event.suggestion.categories': 'færre kategorier',
  'discoveryState.event.constraint.radius': 'innenfor {distance} km',
  'discoveryState.event.constraint.today': 'fra i dag',
  'discoveryState.event.constraint.weekend': 'denne helgen',
  'discoveryState.event.constraint.nextWeek': 'neste uke',
  'discoveryState.event.constraint.specific': 'fra {date}',
  'discoveryState.event.constraint.allCategories': 'alle kategorier',
  'discoveryState.event.constraint.categories': '{categories}',
  'discoveryState.event.constraint.family': 'familievennlig',
  'discoveryState.event.constraint.accessible': 'rullestoltilgjengelig',
  'discoveryState.event.constraint.venues': 'bare verifiserte steder',
  'discoveryState.event.constraint.mutualAttending': 'felles kontakter deltar',
  'discoveryState.event.constraint.mutualHosting': 'arrangert av felles kontakter',
  'discoveryState.community.errorTitle': 'Fellesskapsoppføringene kunne ikke lastes',
  'discoveryState.community.errorBody': 'Kontroller tilkoblingen og prøv å laste fellesskapene på nytt.',
  'discoveryState.community.emptyAllTitle': 'Ingen fellesskap funnet nær {location}',
  'discoveryState.community.emptyGroupTitle': 'Ingen grupper funnet nær {location}',
  'discoveryState.community.emptyBusinessTitle': 'Ingen bedrifter funnet nær {location}',
  'discoveryState.community.emptyBody': 'Ingen oppføringer samsvarer med denne kombinasjonen av fellesskapsfiltre.',
  'discoveryState.community.viewAll': 'Vis alle fellesskap',
  'discoveryState.community.constraint.distance': 'innenfor {distance} km',
  'discoveryState.community.constraint.name': 'navn «{name}»',
  'discoveryState.community.constraint.categories': '{count} kategorier',
  'discoveryState.community.constraint.upcoming': 'kommende arrangementer kreves',
  'discoveryState.community.constraint.popularity': 'sortert etter popularitet',
  'discoveryState.community.constraint.nameSort': 'sortert etter navn',
  'discoveryState.community.constraint.all': 'grupper og bedrifter',
  'discoveryState.community.constraint.group': 'bare grupper',
  'discoveryState.community.constraint.business': 'bare bedrifter',
  'discoveryState.search.errorTitle': 'Søket kunne ikke fullføres',
  'discoveryState.search.errorBody': 'Kontroller tilkoblingen og prøv dette søket på nytt.',
  'discoveryState.search.emptyTitle': 'Ingen resultater for «{query}»',
  'discoveryState.search.emptyConstrained': 'Ingen resultater samsvarer med denne kombinasjonen av søkefiltre.',
  'discoveryState.search.emptyDefault': 'Ingenting i den nåværende katalogen samsvarer med dette søket ennå.',
  'discoveryState.search.reset': 'Nullstill søkefiltre',
  'discoveryState.search.context': '«{query}» · {types} · {upcoming}{location}',
  'discoveryState.search.allTypes': 'alle resultattyper',
  'discoveryState.search.noTypes': 'ingen resultattyper',
  'discoveryState.search.upcoming': 'bare kommende arrangementer',
  'discoveryState.search.allDates': 'alle arrangementsdatoer',
  'discoveryState.search.location': ' · innenfor {distance} km fra {location}',
  'actionable.retry': 'Prøv igjen',
  'actionable.refresh': 'Oppdater',
  'actionable.offlineTitle': 'Du er frakoblet',
  'actionable.offlineBody': 'Viser lagret innhold. Nylige endringer vises kanskje ikke før du kobler til igjen.',
  'actionable.offlineEmptyBody': 'Det finnes ikke lagret innhold for denne delen ennå. Koble til igjen og prøv på nytt.',
  'actionable.feed.title': 'Strømmen din venter på aktivitet',
  'actionable.feed.body': 'Bli med i en gruppe eller meld deg på et arrangement for å se relevante oppdateringer her.',
  'actionable.feed.exploreEvents': 'Utforsk arrangementer',
  'actionable.feed.findGroups': 'Finn grupper',
  'actionable.feed.filteredTitle': 'Ingen aktivitet under {filter} ennå',
  'actionable.feed.filteredBody': 'Andre deler av strømmen kan allerede ha aktivitet.',
  'actionable.feed.showAll': 'Vis all aktivitet',
  'actionable.feed.filter.events': 'arrangementer',
  'actionable.feed.filter.notifications': 'varsler',
  'actionable.feed.filter.groups': 'gruppeaktivitet',
  'actionable.feed.errorTitle': 'Strømmen kunne ikke lastes',
  'actionable.feed.errorBody': 'Kontroller tilkoblingen og prøv å laste strømmen på nytt.',
  'actionable.savedFeeds.title': 'Lagre en oppdagelsesstrøm',
  'actionable.savedFeeds.body': 'Lagre nyttige arrangement- eller gruppefiltre og finn dem igjen her.',
  'actionable.savedFeeds.explore': 'Finn en strøm å lagre',
  'actionable.savedFeeds.errorTitle': 'Lagrede strømmer kunne ikke lastes',
  'actionable.savedFeeds.errorBody': 'Kontroller tilkoblingen og prøv å laste de lagrede strømmene på nytt.',
  'actionable.eventUpdates.title': 'Ingen arrangementsoppdateringer ennå',
  'actionable.eventUpdates.body': 'Invitasjoner, påminnelser og endringer fra arrangementene dine vises her.',
  'actionable.eventUpdates.errorTitle': 'Arrangementsoppdateringene kunne ikke lastes',
  'actionable.eventUpdates.errorBody': 'Kontroller tilkoblingen og prøv igjen.',
  'actionable.groupUpdates.title': 'Ingen oppdateringer under {filter} ennå',
  'actionable.groupUpdates.body': 'Aktivitet fra grupper du blir med i vises i denne delen.',
  'actionable.groupUpdates.errorTitle': 'Gruppeoppdateringene kunne ikke lastes',
  'actionable.groupUpdates.errorBody': 'Kontroller tilkoblingen og prøv igjen.',
  'actionable.groupUpdates.filter.social': 'sosiale',
  'actionable.groupUpdates.filter.membership': 'medlemskap',
  'actionable.groupUpdates.filter.events': 'arrangement',
  'actionable.updates.notifications': 'Juster varsler',
  'actionable.myEvents.filteredTitle': 'Ingen arrangementer samsvarer med «{query}»',
  'actionable.myEvents.filteredBody': 'Tøm søket for å se alle invitasjoner, lagrede arrangementer, planer og historikk.',
  'actionable.clearSearch': 'Tøm søk',
  'actionable.myEvents.createdTitle': 'Opprett ditt første arrangement',
  'actionable.myEvents.createdBody': 'Start et arrangement selv, eller bruk arrangøroppsettet for en veiledet sjekkliste.',
  'actionable.myEvents.create': 'Opprett arrangement',
  'actionable.myEvents.organizer': 'Arrangøroppsett',
  'actionable.myEvents.savedTitle': 'Ingen lagrede arrangementer ennå',
  'actionable.myEvents.savedBody': 'Bokmerk arrangementer du vurderer, så vises de her.',
  'actionable.myEvents.upcomingTitle': 'Kalenderen din er ledig',
  'actionable.myEvents.upcomingBody': 'Utforsk lokale arrangementer når du er klar for å legge en plan.',
  'actionable.myEvents.errorTitle': 'Arrangementene dine kunne ikke lastes',
  'actionable.myEvents.errorBody': 'Kontroller tilkoblingen og prøv å laste arrangementene på nytt.',
  'actionable.myGroups.ownedTitle': 'Opprett din første gruppe',
  'actionable.myGroups.ownedBody': 'Start et fellesskap selv, eller bruk arrangøroppsettet for en veiledet sjekkliste.',
  'actionable.myGroups.create': 'Opprett gruppe',
  'actionable.myGroups.membershipTitle': 'Du har ikke blitt med i en gruppe ennå',
  'actionable.myGroups.membershipBody': 'Utforsk lokale fellesskap og finn et som passer.',
  'actionable.myGroups.filteredTitle': 'Ingen grupper samsvarer med «{query}»',
  'actionable.myGroups.filteredBody': 'Tøm søket for å se alle gruppene dine.',
  'actionable.myGroups.errorTitle': 'Gruppene dine kunne ikke lastes',
  'actionable.myGroups.errorBody': 'Kontroller tilkoblingen og prøv å laste gruppene på nytt.',
  'actionable.myGroups.explore': 'Utforsk grupper',
  'actionable.organizer.firstTitle': 'Velg hvordan du vil være vert',
  'actionable.organizer.firstBody': 'Opprett en gruppe for et fast fellesskap, eller bruk den personlige profilen din for et uformelt arrangement.',
  'actionable.organizer.completeTitle': 'Arrangøroppsettet er fullført',
  'actionable.organizer.completeBody': 'Hold fremdriften oppe ved å planlegge det neste arrangementet.',
  'actionable.organizer.errorTitle': 'Arrangørfremdriften kunne ikke lastes',
  'actionable.organizer.errorBody': 'Kontroller tilkoblingen og prøv å laste sjekklisten på nytt.',
  'actionable.organizer.createAnother': 'Opprett et nytt arrangement',
  'actionable.history.title': 'Ingen fullførte arrangementer ennå',
  'actionable.history.body': 'Arrangementer du deltar på blir tilgjengelige for private notater og bilder etter at de er ferdige.',
  'actionable.history.errorTitle': 'Minnene dine kunne ikke lastes',
  'actionable.history.errorBody': 'Kontroller tilkoblingen og prøv å laste minnene på nytt.',
  'actionable.groupEvents.emptyTitle': 'Ingen gruppearrangementer ennå',
  'actionable.groupEvents.ownerBody': 'Opprett gruppens første arrangement når detaljene er klare.',
  'actionable.groupEvents.viewerBody': 'Gruppen har ikke publisert et arrangement ennå. Du kan utforske andre arrangementer i nærheten.',
  'actionable.groupEvents.create': 'Opprett arrangement',
  'actionable.groupEvents.explore': 'Utforsk arrangementer',
  'actionable.groupEvents.errorTitle': 'Gruppearrangementene kunne ikke lastes',
  'actionable.groupEvents.errorBody': 'Kontroller tilkoblingen og prøv å laste gruppearrangementene på nytt.',
  'actionable.groupPosts.emptyTitle': 'Ingen gruppeinnlegg ennå',
  'actionable.groupPosts.authorBody': 'Del den første oppdateringen med gruppen.',
  'actionable.groupPosts.viewerBody': 'Oppdateringer vises her når gruppemedlemmer publiserer dem.',
  'actionable.groupPosts.write': 'Skriv det første innlegget',
  'actionable.groupPosts.events': 'Vis gruppearrangementer',
  'actionable.groupPosts.errorTitle': 'Gruppeinnleggene kunne ikke lastes',
  'actionable.groupPosts.errorBody': 'Kontroller tilkoblingen og prøv å laste innleggene på nytt.',
  'actionable.businessPosts.emptyTitle': 'Ingen bedriftsoppdateringer ennå',
  'actionable.businessPosts.authorBody': 'Publiser den første oppdateringen for dette fellesskapet.',
  'actionable.businessPosts.viewerBody': 'Oppdateringer vises her når bedriften publiserer dem.',
  'actionable.businessPosts.write': 'Skriv den første oppdateringen',
  'actionable.businessPosts.events': 'Vis arrangementer',
  'actionable.businessPosts.errorTitle': 'Bedriftsoppdateringene kunne ikke lastes',
  'actionable.businessPosts.errorBody': 'Kontroller tilkoblingen og prøv å laste oppdateringene på nytt.',
  'eventDiscovery.category': 'Kategori',
  'eventDiscovery.distance': 'Avstand',
  'eventDiscovery.enableMapDragging': 'Slå på kartflytting',
  'eventDiscovery.lockMapPosition': 'Lås kartposisjonen',
  'discoveryFilters.filters': 'Filtre',
  'discoveryFilters.communityTitle': 'Filtrer fellesskap',
  'discoveryFilters.activeCount': '{count} aktive',
  'discoveryFilters.reset': 'Nullstill',
  'discoveryFilters.date': 'Dato',
  'discoveryFilters.today': 'I dag',
  'discoveryFilters.weekend': 'Denne helgen',
  'discoveryFilters.nextWeek': 'Neste uke',
  'discoveryFilters.specificDate': 'Bestemt dato',
  'discoveryFilters.chooseDate': 'Velg dato',
  'discoveryFilters.selectCategories': 'Velg kategorier',
  'discoveryFilters.categoryCount': 'Ingen kategorier | Én kategori | {count} kategorier',
  'discoveryFilters.removeCategory': 'Fjern {name}',
  'discoveryFilters.removeCategories': 'Fjern kategorifiltre',
  'discoveryFilters.removeDate': 'Fjern datofilter',
  'discoveryFilters.nearMe': 'Nær meg',
  'discoveryFilters.location': 'Sted',
  'discoveryFilters.locationPlaceholder': 'Velg en by eller et sted',
  'discoveryFilters.locationSearching': 'Søker etter steder …',
  'discoveryFilters.locationNoResults': 'Ingen steder samsvarer',
  'discoveryFilters.locationSearchError': 'Stedssøk er utilgjengelig.',
  'discoveryFilters.locationResults': '{count} stedsresultater er tilgjengelige.',
  'discoveryFilters.locationSelected': '{name} er valgt.',
  'discoveryFilters.selectedArea': 'Valgt område',
  'discoveryFilters.exactLocation': 'Nøyaktig posisjon',
  'discoveryFilters.locationIssue.denied': 'Posisjonstilgang ble ikke tillatt.',
  'discoveryFilters.locationIssue.unavailable': 'Nåværende posisjon er utilgjengelig.',
  'discoveryFilters.locationIssue.error': 'Nåværende posisjon kunne ikke lastes.',
  'discoveryFilters.accessAudience': 'Tilgang og målgruppe',
  'discoveryFilters.familyFriendly': 'Familievennlige arrangementer',
  'discoveryFilters.wheelchairAccessible': 'Rullestoltilgjengelige steder',
  'discoveryFilters.verifiedVenues': 'Bare arrangementer fra verifiserte steder',
  'discoveryFilters.mutualAttending': 'Felles kontakter deltar',
  'discoveryFilters.mutualHosting': 'Arrangert av felles kontakter',
  'discoveryFilters.discoveryType': 'Utforskningstype',
  'discoveryFilters.all': 'Alle',
  'discoveryFilters.groups': 'Grupper',
  'discoveryFilters.businesses': 'Bedrifter',
  'discoveryFilters.sortBy': 'Sorter etter',
  'discoveryFilters.popularity': 'Popularitet',
  'discoveryFilters.nameSort': 'Navn',
  'discoveryFilters.name': 'Navn',
  'discoveryFilters.keywordsPlaceholder': 'Skriv inn søkeord',
  'discoveryFilters.upcomingEvents': 'Har kommende arrangementer',
  'discoveryFilters.removeName': 'Fjern navnefilter',
  'discoveryFilters.removeUpcoming': 'Fjern filter for kommende arrangementer',
  'discoveryFilters.countingResults': 'Teller resultater …',
  'discoveryFilters.countError': 'Resultatantallet kunne ikke lastes.',
  'discoveryFilters.showResults': 'Vis ingen resultater | Vis ett resultat | Vis {count} resultater',
  'discoveryFilters.showResultsFallback': 'Vis resultater',
  'discoveryFilters.chooseLocationAction': 'Velg et sted',
  'resourceBooking.eyebrow': 'Bedrifter',
  'resourceBooking.title': 'Bestill en ressurs',
  'resourceBooking.intro':
    'Reserver rom, baner, utstyr, bord og instruktørtid. Vist tilgjengelighet er veiledende. Plassen din er først sikret etter bekreftelse.',
  'resourceBooking.available': 'Tilgjengelige ressurser',
  'resourceBooking.empty': 'Ingen ressurser er tilgjengelige akkurat nå.',
  'resourceBooking.descriptionFallback': 'Bestill direkte hos denne bedriften.',
  'resourceBooking.capacity': 'Kapasitet {count}',
  'resourceBooking.minimumMinutes': 'Minst {minutes} min',
  'resourceBooking.kind.room': 'Rom',
  'resourceBooking.kind.court': 'Bane',
  'resourceBooking.kind.table': 'Bord',
  'resourceBooking.kind.equipment': 'Utstyr',
  'resourceBooking.kind.instructor': 'Instruktør',
  'resourceBooking.kind.other': 'Annet',
  'resourceBooking.myBookings': 'Mine bestillinger',
  'resourceBooking.bookingsEmpty': 'Bekreftede bestillinger og aktive reservasjoner vises her.',
  'resourceBooking.bookingFallback': 'Ressursbestilling',
  'resourceBooking.status.hold': 'Reservert',
  'resourceBooking.status.pendingPayment': 'Betaling venter',
  'resourceBooking.status.confirmed': 'Bekreftet',
  'resourceBooking.status.cancelled': 'Avbestilt',
  'resourceBooking.status.expired': 'Utløpt',
  'resourceBooking.status.refundPending': 'Refusjon venter',
  'resourceBooking.status.other': 'Behandles',
  'resourceBooking.cancel': 'Avbestill',
  'resourceBooking.cancelled': 'Bestillingen er avbestilt.',
  'resourceBooking.cancelError': 'Bestillingen kunne ikke avbestilles. Prøv igjen.',
  'resourceBooking.close': 'Lukk',
  'resourceBooking.free': 'Gratis',
  'resourceBooking.pricePerSlot': '{price} per {minutes} minutter',
  'resourceBooking.signInBody': 'Logg inn for å bestille.',
  'resourceBooking.signIn': 'Logg inn',
  'resourceBooking.starts': 'Starter',
  'resourceBooking.ends': 'Slutter',
  'resourceBooking.quantity': 'Antall',
  'resourceBooking.advisory':
    'Serveren kontrollerer kapasitet, pauser, sperret tid og overlappende bestillinger samlet. Betalte bestillinger får en betalingsreservasjon på 15 minutter.',
  'resourceBooking.request': 'Send bestilling',
  'resourceBooking.paymentHold': 'Tiden er reservert mens betalingen fullføres.',
  'resourceBooking.confirmed': 'Bestillingen er bekreftet.',
  'resourceBooking.createError': 'Tiden kunne ikke bestilles. Kontroller opplysningene og prøv igjen.',
  'resourceBooking.redirectError': 'Den sikre betalingssiden kunne ikke åpnes. Bestillingen er ikke bekreftet.',
  'travelReminder.title': 'Planlegg når du må dra',
  'travelReminder.intro': 'Bruk posisjonen din én gang for et valgfritt varsel om når du bør dra.',
  'travelReminder.summaryBefore': 'Dra senest',
  'travelReminder.summaryAfter': 'for et {category} estimat med {mode} på {duration}, pluss {buffer}.',
  'travelReminder.category.coarse': 'grovt',
  'travelReminder.category.routed': 'rutebasert',
  'travelReminder.modeLabel': 'Reisemåte',
  'travelReminder.mode.walking': 'gange',
  'travelReminder.mode.cycling': 'sykkel',
  'travelReminder.mode.driving': 'bil',
  'travelReminder.mode.transit': 'kollektivtransport',
  'travelReminder.bufferLabel': 'Ekstra tid',
  'travelReminder.buffer.none': 'Ingen ekstra tid',
  'travelReminder.buffer.minutes': '{minutes} min',
  'travelReminder.create': 'Beregn og varsle meg',
  'travelReminder.estimating': 'Beregner …',
  'travelReminder.remove': 'Fjern påminnelsen',
  'travelReminder.provider.coarse': 'Grovt estimat i luftlinje (ingen ruteveiledning).',
  'travelReminder.provider.mapbox': 'Ruteestimat fra Mapbox Directions.',
  'travelReminder.provider.google': 'Kollektivestimat fra Google.',
  'travelReminder.providerHelp':
    'Gange, sykling og bil bruker ruteestimater fra Mapbox Directions. Kollektivtransport bruker en egen leverandør når den er tilgjengelig.',
  'travelReminder.consentTitle': 'Bruk posisjonen din én gang?',
  'travelReminder.consentBody':
    'Koordinatene dine sendes bare for å beregne estimatet. Vennevent lagrer reisemåte, varighet og påminnelsestidspunkt – ikke startstedet eller ruten din.',
  'travelReminder.consentConfirm': 'Beregn reisen',
  'travelReminder.consentCancel': 'Ikke nå',
  'travelReminder.locationUnsupported': 'Denne nettleseren støtter ikke posisjonstilgang.',
  'travelReminder.locationDenied': 'Posisjonstilgang ble ikke gitt.',
  'travelReminder.created': 'Avreisepåminnelsen er satt.',
  'travelReminder.createError': 'Reisen kunne ikke beregnes. Prøv igjen.',
  'travelReminder.removed': 'Avreisepåminnelsen er fjernet.',
  'travelReminder.removeError': 'Påminnelsen kunne ikke fjernes. Prøv igjen.',
  'booking.loading': 'Laster bestillingsalternativer …',
  'booking.available': 'Tilgjengelig for bestilling',
  'booking.upcoming': 'Kommende arrangementer og økter',
  'booking.noUpcoming': 'Ingen kommende arrangementer eller økter er oppført.',
  'booking.viewDetails': 'Vis detaljer',
  'booking.viewEvent': 'Vis detaljer for {name}',
  'booking.availabilityAdvisory': 'Tid og kapasitet bekreftes sikkert når du går videre.',
  'booking.noneAvailable': 'Ingenting er tilgjengelig for bestilling akkurat nå.',
  'booking.verified': 'Verifisert',
  'booking.coverFor': 'Forsidebilde for {name}',
  'booking.capacity': 'Kapasitet',
  'booking.duration': 'Minste varighet',
  'booking.upTo': 'Opptil {count}',
  'booking.minimumMinutes': 'Minst {minutes} min',
  'booking.free': 'Gratis',
  'booking.perSlot': '{price} / {minutes} min',
  'booking.chooseTime': 'Velg tidspunkt',
  'booking.bookResource': 'Velg et tidspunkt for {name}',
  'booking.poweredBy': 'Sikker bestilling levert av',
  'booking.unavailableTitle': 'Bestillingssiden er utilgjengelig',
  'booking.unavailableBody': 'Denne bedriftssiden kan være satt på pause eller utilgjengelig. Prøv igjen snart.',
  'booking.embedUnavailableBody': 'Bestillingsmodulen kunne ikke lastes. Prøv igjen eller kontakt bedriften.',
  'orders.eyebrow': 'Kundeselvbetjening',
  'orders.title': 'Kjøp og bestillinger',
  'orders.intro': 'Arrangementskjøp, billetter, ressursbestillinger, kvitteringer, refusjonsstatus og støttereferanser på ett privat sted.',
  'orders.filterLabel': 'Filtrer kjøp og bestillinger',
  'orders.filter.all': 'Alle',
  'orders.filter.event': 'Arrangementer',
  'orders.filter.resource': 'Ressurser',
  'orders.kind.event': 'Arrangement',
  'orders.kind.resource': 'Ressurs',
  'orders.status.pending': 'Betaling venter',
  'orders.status.authorized': 'Bekreftet',
  'orders.status.paid': 'Betalt',
  'orders.status.failed': 'Betaling mislyktes',
  'orders.status.cancelled': 'Avbestilt',
  'orders.status.expired': 'Utløpt',
  'orders.status.refund_pending': 'Refusjon venter',
  'orders.status.partially_refunded': 'Delvis refundert',
  'orders.status.refunded': 'Refundert',
  'orders.status.confirmed': 'Bekreftet',
  'orders.status.hold': 'Reservert',
  'orders.emptyTitle': 'Ingen kjøp eller bestillinger ennå',
  'orders.emptyBody': 'Fullførte betalinger og ressursreservasjoner vises her.',
  'orders.refundPending': 'Vipps behandler refusjonen. Statusen oppdateres etter bekreftelse fra leverandøren.',
  'orders.paymentIncomplete': 'Betalingen ble ikke fullført. Ingen kvittering eller bekreftet plass ble utstedt.',
  'orders.ticket': 'Vis billett',
  'orders.ticketAlt': 'QR-billett for {title}',
  'orders.supportReference': 'Støttereferanse',
  'orders.receipt': 'Last ned kvittering',
  'orders.cancel': 'Avbestill og be om refusjon',
  'orders.loadMore': 'Last inn flere',
  'orders.loadError': 'Kjøpene og bestillingene kunne ikke lastes.',
  'orders.receiptError': 'Kvitteringen kunne ikke lastes ned.',
  'orders.cancelError': 'Avbestillingen kunne ikke sendes.',
  'orders.cancelRequested': 'Avbestillingen er sendt. Refusjonsstatus vises her.',
  'orders.customerCancellation': 'Avbestilling via kundeselvbetjening',
  'orders.redirectError': 'Den sikre betalingssiden kunne ikke åpnes. Overføringen venter fortsatt.',
  'format.eventCount': 'ingen arrangementer | ett arrangement | {count} arrangementer',
} as const satisfies TranslationResources;
